import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-create-permiso',
  templateUrl: './dialog-create-permiso.component.html',
  styleUrls: ['./dialog-create-permiso.component.css']
})
export class DialogCreatePermisoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
